<div class="wrapper">
    <ng-content></ng-content>
    <img [ngClass]="{'active': amSorted()}" [src]="arrowUrl">
</div>